const processEnv = typeof process !== 'undefined' ? process.env : {};
const windowEnv = window && window.env ? window.env : {};
const injectedEnv = Object.fromEntries(Object.entries(windowEnv).filter(([, value]) => value))
const env = Object.assign({}, processEnv, injectedEnv);
export { env };
